import React, { Component } from 'react';
import '../styles/style.css';

export class TotalRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    calculatePercentage(members, unemployed) {
        if (unemployed === "0" || members === "0") {
            return "0";
        }

        return parseFloat((((unemployed - members) / members) * 100) + 100).toFixed(2).replace(".", ",");
    }

    render() {
        return (
            <div className='row'>
                <div className='col1'>Total</div>
                <div className='col2'></div>
                <div className='col3'>{this.props.totalMembers}</div>
                <div className='col4'>{this.props.unemployed}</div>
                <div className='col5'>{this.calculatePercentage(this.props.totalMembers, this.props.unemployed)}%</div>
                <div className='col6'>{this.props.affected}</div>
                <div className='col7'>{this.calculatePercentage(this.props.totalMembers, this.props.affected)}%</div>
            </div>
        );
    }
}